import packageJson from "../package.json";

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  basePath: string;
  assetsDir: string;
  isStaticExport: boolean;
  auth: {
    method: "supabase";
    skip: boolean;
    redirectPath: string;
  };
  supabase: { url: string; key: string };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: "Claire",
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? "",
  basePath: import.meta.env.VITE_BASE_PATH ?? "",
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? "",
  isStaticExport: JSON.parse(
    `${import.meta.env.BUILD_STATIC_EXPORT ?? "false"}`
  ),
  /**
   * Auth
   * @method supabase
   */
  auth: {
    method: "supabase",
    skip: false,
    redirectPath: "/dashboard",
  },
  /**
   * Supabase
   */
  supabase: {
    url: import.meta.env.VITE_SUPABASE_URL ?? "",
    key: import.meta.env.VITE_SUPABASE_ANON_KEY ?? "",
  },
};
